var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "files" };
const _hoisted_2 = {
    key: 1,
    class: "grid col-span-3 gap-6 container-files sm:grid-cols-2 md:grid-cols-5 sm:gap-y-8 lg:gap-x-8"
};
const _hoisted_3 = { key: 2 };
import { FolderIcon, Link02Icon, TextInputIcon, Trash01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { renderIcon, UITextSmMedium } from '@gohighlevel/ghl-ui';
import { computed, inject, ref } from 'vue';
import { VueDraggableNext as draggable } from 'vue-draggable-next';
import { useI18n } from 'vue-i18n';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import ContextMenu from '../components/ContextMenu.vue';
import FileItem from '../components/FileItem.vue';
import TableView from '../components/TableView.vue';
import { useFile } from '../composable/fileUpload';
import useContextMenu from '../composable/useContextMenu';
import useEmitter from '../composable/useEmitter';
import { useEvent } from '../composable/useEvent';
import MediaService from '../services/MediaService';
import { useStore } from '../store';
import { MIME_TYPES } from '../util/const_helper';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilesView',
    props: {
        files: { default: () => [] },
        mediaLayout: {},
        count: {},
        category: {}
    },
    emits: ["paginatedQuery"],
    setup(__props, { emit: __emit }) {
        const emitter = useEmitter();
        const emit = __emit;
        const { sendNotification } = useEvent();
        const { t } = useI18n();
        const parentEmitter = inject('emitter');
        const { $state, updateActiveObject, updatePreviewItem } = useStore();
        const alerting = ref(false);
        const activeItem = computed(() => $state.activeItem._id);
        const mediaFile = ref(null);
        const clickTimeout = ref(null);
        const contextMenuItems = [
            {
                name: t('common.getLink'),
                slug: 'link',
                icon() {
                    return renderIcon(Link02Icon);
                },
            },
            {
                name: t('common.moveToFolder'),
                slug: 'move',
                icon() {
                    return renderIcon(FolderIcon);
                },
            },
            {
                name: t('common.rename'),
                slug: 'rename',
                icon() {
                    return renderIcon(TextInputIcon);
                },
            },
            {
                name: t('common.delete'),
                slug: 'delete',
                icon() {
                    return renderIcon(Trash01Icon);
                },
            },
        ];
        function onSelectFile(file) {
            updateActiveObject(file);
            emitter.emit('media-select-option', {
                file: file,
                fileType: 'file',
            });
        }
        function onClickImage(file) {
            updatePreviewItem({
                url: file.url,
                name: file.name,
                size: file.size,
                published: file.updatedAt,
                _id: file._id,
                blurHashCode: file.blurHashCode,
                height: file.height,
                width: file.width,
                showDownload: !$state.mediaModal,
                showCopyLink: true,
            });
            if (clickTimeout.value) {
                clearTimeout(clickTimeout.value);
                clickTimeout.value = null;
            }
            clickTimeout.value = setTimeout(() => {
                if (file.contentType.startsWith('image') &&
                    Object.keys($state.previewItem).length > 0) {
                    emitter.emit('showPreview');
                }
                clickTimeout.value = null;
            }, 300);
        }
        const { contextMenuItemClick } = useContextMenu();
        const contextMenuRef = ref();
        function handleFileClick(event, item) {
            contextMenuRef.value.showMenu(event, item);
            mediaFile.value = item;
        }
        function checkFormatList(allowedList) {
            var _a;
            return ((_a = allowedList === null || allowedList === void 0 ? void 0 : allowedList.reduce((results, format) => {
                var _a;
                if (format === 'documents') {
                    Object.values(MIME_TYPES.documents).forEach(mimeTypes => {
                        results.push(...mimeTypes);
                    });
                }
                else {
                    results.push(...((_a = MIME_TYPES === null || MIME_TYPES === void 0 ? void 0 : MIME_TYPES[format]) !== null && _a !== void 0 ? _a : []));
                }
                return results;
            }, [])) !== null && _a !== void 0 ? _a : []);
        }
        function isSupported(file) {
            const toCheck = checkFormatList($state.allowedExtensions);
            return toCheck.includes(file === null || file === void 0 ? void 0 : file.contentType);
        }
        function onclickFileSelect(file) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                if (clickTimeout.value) {
                    clearTimeout(clickTimeout.value);
                    clickTimeout.value = null;
                }
                $state.activeItem = {};
                if (!isSupported(file)) {
                    alerting.value = true;
                    sendNotification({
                        type: 'error',
                        duration: 2000,
                        title: t('common.fileTypeNoSupported'),
                    });
                    alerting.value = false;
                    return;
                }
                if ($state) {
                    const data = {
                        id: file._id,
                        name: file.name,
                        url: file.url,
                        type: file.contentType,
                    };
                    let isError = false;
                    if ($state.selfHosted) {
                        const now = new Date();
                        const processingStartedAt = new Date(file.processingStartedAt);
                        const diffTime = Math.abs(now.getTime() - processingStartedAt.getTime());
                        const diffDays = diffTime / (1000 * 60 * 60 * 24);
                        isError =
                            file.isEncoded == false &&
                                (diffDays >= 1 || file.encodingInProgress == false);
                    }
                    if ($state.selfHosted && (file.isEncoded === undefined || isError)) {
                        updateActiveObject(file);
                        alerting.value = true;
                        sendNotification({
                            duration: 2000,
                            type: 'success',
                            title: t('common.initiateEncoding'),
                        });
                        const params = {
                            fileId: file._id,
                            altId: file.altId,
                            altType: file.altType,
                        };
                        if (isError)
                            params.reEncoding = true;
                        yield MediaService.initiateEncoding(params);
                        console.info('Initiating encoding successful!');
                        setTimeout(() => {
                            parentEmitter.emit('media-center:attachment', data);
                            alerting.value = false;
                        }, 2000);
                    }
                    else {
                        const { validateFileUpload } = useFile();
                        file.type = file.contentType;
                        try {
                            validateFileUpload(file);
                        }
                        catch (err) {
                            sendNotification({
                                type: 'error',
                                duration: 5000,
                                title: (_a = err === null || err === void 0 ? void 0 : err.message) !== null && _a !== void 0 ? _a : 'Something went wrong',
                            });
                            return false;
                        }
                        alerting.value = false;
                        parentEmitter.emit('media-center:attachment', data);
                    }
                }
            });
        }
        function onDragEnd(evt) {
            const element = evt.target;
            element.classList.remove('sortable-drag');
        }
        const pageChange = e => {
            emit('paginatedQuery', e);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.files.length > 0 && _ctx.category === 'all')
                    ? (_openBlock(), _createBlock(_unref(UITextSmMedium), {
                        key: 0,
                        class: "pb-2 text-gray-600"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.files')), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (_ctx.mediaLayout === 'grid')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                            return (_openBlock(), _createBlock(_unref(draggable), {
                                class: "w-full dragArea list-group drag-item h-full",
                                key: file._id,
                                list: [file],
                                group: { name: 'files', put: false, pull: 'clone' },
                                ghostClass: 'ghost'
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(FileItem, {
                                        id: file._id,
                                        onClick: ($event) => (alerting.value ? undefined : onSelectFile(file)),
                                        activeItem: activeItem.value,
                                        file: file,
                                        class: "h-100 file-item",
                                        onDragend: onDragEnd,
                                        onContextmenu: _withModifiers(($event) => (handleFileClick($event, file)), ["prevent", "stop"]),
                                        disabled: alerting.value,
                                        onDblclick: ($event) => (alerting.value ? undefined : onclickFileSelect(file)),
                                        onOnClickImage: ($event) => (onClickImage(file))
                                    }, null, 8, ["id", "onClick", "activeItem", "file", "onContextmenu", "disabled", "onDblclick", "onOnClickImage"])
                                ]),
                                _: 2
                            }, 1032, ["list"]));
                        }), 128)),
                        _createVNode(ContextMenu, {
                            elementId: 'filesMenu',
                            options: contextMenuItems,
                            ref_key: "contextMenuRef",
                            ref: contextMenuRef,
                            onOptionClicked: _unref(contextMenuItemClick)
                        }, null, 8, ["onOptionClicked"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_ctx.files.length || _ctx.category !== 'all')
                            ? (_openBlock(), _createBlock(TableView, {
                                key: 0,
                                id: "identifier.BlogList_Table",
                                data: _ctx.files,
                                count: _ctx.count,
                                onPageChange: pageChange,
                                type: "file"
                            }, null, 8, ["data", "count"]))
                            : _createCommentVNode("", true)
                    ]))
            ]));
        };
    }
});
